import React from 'react'
import { connect } from 'react-redux'
import MarkdownWrapper from '../../utils/markdown-wrapper'

const ThreeFacts = ({ contentBand }) => {
    const renderFacts = () => {
        let allFacts = []
        if (contentBand?.data && contentBand.data.length > 0) {
            contentBand.data.forEach((fact, index) => {
                allFacts.push(
                    <div className="fact" key={index}>
                        <div className="icon"><img src={fact.image?.url} alt={fact.image?.alt} /></div>
                        <div className="details">
                            <h3 className="title">{fact.title}</h3>
                            <div className="text">
                                <MarkdownWrapper content={fact.content} />
                            </div>
                        </div>
                    </div>
                )
            })
        }
        return allFacts
    }

    return (
        <div className="facts-wrapper">
            {renderFacts()}
        </div>
    )
}

export default connect()(ThreeFacts)
